module.exports = __webpack_public_path__ + "img/grand-cancun-hotel-5.4aa6a0a2.jpg";